import { autoserialize } from 'cerialize';

import { BaseDTO, IBaseDTO } from './base-dto';
import { ISplitScreen, SplitScreen } from './split-screen';

export class LandingConfiguration extends BaseDTO implements ILandingConfiguration {
  @autoserialize id?: string;
  @autoserialize resource_type?: string;
  @autoserialize resource_id?: string;
  @autoserialize configuration?: SplitScreen;

  constructor(payload?: ILandingConfiguration) {
    super(payload);
    this.id = payload?.id?.toString();
    this.resource_type = payload?.resource_type;
    this.resource_id = payload?.resource_id;
    this.configuration = new SplitScreen(payload?.configuration);
  }
}

export interface ILandingConfiguration extends IBaseDTO {
  id?: string;
  resource_type?: string;
  resource_id?: string;
  configuration?: ISplitScreen;
}
